import { useQuoteContext } from '../context/quote.js';
import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import { useThrottleValue } from '@exodus/react-hooks';
import { useToAssets } from '../context/assets.js';
import { useAddingCustomTokenContext } from '../context/adding-custom-token.js';
const useToSideLoading = () => {
    const selectors = useSelectors();
    const quote = useQuoteContext();
    const fiatRatesLoading = useSelector(selectors.rates.loading);
    const availableToAssets = useToAssets();
    const [addingCustomToken] = useAddingCustomTokenContext();
    const isAddingCustomToken = Boolean(addingCustomToken);
    const isLoadingData = Boolean(fiatRatesLoading || quote.loading || availableToAssets.loading);
    const isLoadingDataThrottled = useThrottleValue(isLoadingData, 300);
    return isAddingCustomToken || isLoadingDataThrottled;
};
export default useToSideLoading;
